const APP_VERSION =
  typeof __APP_VERSION__ === "string" ? __APP_VERSION__ : "desarrollo";
const APP_BUILD_TIME =
  typeof __APP_BUILD_TIME__ === "string" ? __APP_BUILD_TIME__ : "";

const parsedBuildTime = new Date(APP_BUILD_TIME);
const buildTimeLabel = Number.isNaN(parsedBuildTime.getTime())
  ? "compilación local"
  : new Intl.DateTimeFormat("es-VE", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    }).format(parsedBuildTime);

export default function AppVersionBadge() {
  return (
    <div
      className="pointer-events-auto inline-flex items-center gap-2 rounded-full border border-white/15 bg-slate-950/95 px-3 py-1.5 text-[9px] font-black text-slate-200 shadow-xl backdrop-blur"
      data-testid="app-version"
      title={`Versión instalada ${APP_VERSION}. Compilada el ${buildTimeLabel}. Si este dato cambia después de desplegar, EasyPanel cargó la publicación nueva.`}
    >
      <span
        aria-hidden="true"
        className="h-2 w-2 rounded-full bg-emerald-400 shadow-[0_0_8px_rgba(52,211,153,0.8)]"
      />
      <span>Versión instalada v{APP_VERSION}</span>
      <span className="text-slate-500">·</span>
      <time dateTime={APP_BUILD_TIME} className="font-mono text-slate-400">
        {buildTimeLabel}
      </time>
    </div>
  );
}
